/**
 * @generated SignedSource<<ba302b224d0fdb2e6d0db9c8ed77713e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserDropdownItemFragment$data = {
  readonly fullName: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment">;
  readonly " $fragmentType": "UserDropdownItemFragment";
};
export type UserDropdownItemFragment$key = {
  readonly " $data"?: UserDropdownItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserDropdownItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserDropdownItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileAvatarFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f5de700361277ab750802cadcadd0580";

export default node;
